import request from '@/utils/request'

// 关注列表
export function followSectionList(params) {
  return request({
    url: '/follow/followSectionList' ,
    method: 'get',
    params:params
  })
}
// 我的投标
export function signupList(params) {
  return request({
    url: '/quotation/signup/list' ,
    method: 'get',
    params:params
  })
}
// 我的问题列表
export function questionListSelf(params) {
  return request({
    url: '/question/question/listSelf' ,
    method: 'get',
    params:params
  })
}
// 新增我的问题
export function questionPost(data) {
  return request({
    url: '/question/question' ,
    method: 'post',
    data:data
  })
}
// 修改我的问题 
export function questionPut(data) {
  return request({
    url: '/question/question' ,
    method: 'put',
    data:data
  })
}
// 我的问题详情
export function questionGet(id) {
  return request({
    url: '/question/question/'+id ,
    method: 'get',
  })
}
//我的问题 删除
export function questionDel(id) {
  return request({
    url: '/question/question/'+id ,
    method: 'delete',
  })
}
// 查询报价详情
export function systemQuotes(id) {
  return request({
    url: '/system/quotes/'+id+'/0' ,
    method: 'get',
  })
}
//供应商查询历史报价
export function getQuotationInfo(id) {
  return request({
    url: '/system/quotes/getQuotationInfo/'+id,
    method: 'get',
  })
}
// 报价
export function systemQuotesPost(data) {
  return request({
    url: '/system/quotes' ,
    method: 'post',
    data:data
  })
}
// 公司资质查询
export function bidCompany(id) {
  return request({
    url: '/bidCompany/'+id ,
    method: 'get',
  })
}
// 公司资质修改
export function bidCompanyPut(data) {
  return request({
    url: '/bidCompany' ,
    method: 'put',
    data:data
  })
}

// 查询报价详情
export function exportSectors(id,name) {
  return request({
    url: '/system/quotes/exportSectors/'+id+'/0' ,
    method: 'post',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    responseType: 'blob'
  }).then((res) => {
    const blob = new Blob([res], {type: res.type});
    const eLink = document.createElement("a");
    eLink.download = name+".xlsx";
    eLink.style.display = "none";
    eLink.href = URL.createObjectURL(blob);
    document.body.appendChild(eLink);
    eLink.click();
    const a = URL.revokeObjectURL(eLink.href); // 释放

  }).catch((res) => {
    console.log(res);
  });
}

// 查询报价详情
export function exportSectorsDetails(id,name) {
  return request({
    url: '/system/quotes/exportSectorsDetails/'+id+'/0' ,
    method: 'post',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    responseType: 'blob'
  }).then((res) => {
    const blob = new Blob([res], {type: res.type});
    const eLink = document.createElement("a");
    eLink.download = name+".xlsx";
    eLink.style.display = "none";
    eLink.href = URL.createObjectURL(blob);
    document.body.appendChild(eLink);
    eLink.click();
    const a = URL.revokeObjectURL(eLink.href); // 释放

  }).catch((res) => {
    console.log(res);
  });
}

// 导入
export function importFileSectors(id,formData) {
  return request({
    url: '/system/quotes/importFileSectors/'+id+'/0',
    method: 'post',
    data: formData,
    timeout: 300000
  })
}
//总包导入
export function sectionDetailImport(id,formData) {
  return request({
    url: '/system/quotes/sectionDetailImport/'+id+'/0',
    method: 'post',
    data: formData,
    timeout: 300000
  })
}
// 导入
export function importFileSectorsDetails(id,formData) {
  return request({
    url: '/system/quotes/importFileSectorsDetails/'+id+'/0',
    method: 'post',
    data: formData,
    timeout: 300000
  })
}
// 查询报价结束时间
export function selectendtime(id) {
  return request({
    url: '/system/section/selectendtime/'+id,
    method: 'get',
  })
}
// 事件处理 列表查询
export function clientList(params) {
  return request({
    url: '/material/supplierMaterialApprove/client/list',
    method: 'get',
    params:params
  })
}
// 事件处理 导出
export function supplierMaterialApproveExport(params) {
  return request({
    url: '/material/supplierMaterialApprove/export',
    method: 'get',
    params:params
  })
}
// 事件处理 导入
export function supplierMaterialApproveImport(formData) {
  return request({
    url: '/material/supplierMaterialApprove/import',
    method: 'post',
    data: formData,
    timeout: 300000
  })
}
// 提交
export function supplierMaterialApprovePut(data) {
  return request({
    url: '/material/supplierMaterialApprove' ,
    method: 'put',
    data:data
  })
}
// 批量提交 
export function batchSubmit(id) {
  return request({
    url: '/material/supplierMaterialApprove/batchSubmit/'+id ,
    method: 'get',
  })
}


// 分包查询报价详情
export function sectionDetailExport(id,name) {
  return request({
    url: '/system/quotes/sectionDetailExport/'+id ,
    method: 'post',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    responseType: 'blob'
  }).then((res) => {
    const blob = new Blob([res], {type: res.type});
    const eLink = document.createElement("a");
    eLink.download = name+".xlsx";
    eLink.style.display = "none";
    eLink.href = URL.createObjectURL(blob);
    document.body.appendChild(eLink);
    eLink.click();
    const a = URL.revokeObjectURL(eLink.href); // 释放

  }).catch((res) => {
    console.log(res);
  });
}

// 完善报价的数据 标段下的明细
export function getConfirmationSupplierPrice(sectionId) {
  return request({
    url: '/quotation/signup/getConfirmationSupplierPrice/'+sectionId ,
    method: 'get',
  })
}


// 备件信息完善列表
export function getMaterialPartBySupplier(params) {
  return request({
    url: '/quotation/materialPart/getMaterialPartBySupplier' ,
    method: 'get',
    params:params

  })
}
//详情
export function getMaterialPart(id) {
  return request({
    url: '/quotation/materialPart/'+id ,
    method: 'get',
  })
}
//提交
export function PutMaterialPart(data) {
  return request({
    url: '/quotation/materialPart' ,
    method: 'put',
    data:data
  })
}

// 备件的角标数量
export function countMaterialPartPending() {
  return request({
    url: '/quotation/materialPart/countMaterialPartPending' ,
    method: 'get',
  })
}
